import { Injectable } from '@angular/core';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class BrokerService {

  constructor(private apiHelper: ApiHelper) { }

  list() {
    return this.apiHelper.get(API_URLS.BROKER)
  }

  add(payload: any) {
    return this.apiHelper.post(API_URLS.BROKER, payload)
  }

  update(id: any, payload: any) {
    return this.apiHelper.put(`${API_URLS.BROKER}/${id}`, payload)
  }
}
